<template>
  <div class="xscrollable px-2">
    <v-card class="d-flex flex-row pb-1">
      <v-card
        v-for="(outputVariable, index) in [...filteredVars]"
        :key="'vc-' + outputVariable.id"
        :class="index > 0 ? 'ml-2 pb-1' : 'pb-1'"
      >
        <output-variable-chart
          :key="'ovc-' + outputVariable.id"
          :variable="outputVariable"
          @userResetOutputVariable="userChangedVariable"
          @userChangedOutputVariable="userChangedVariable"
        />
      </v-card>
    </v-card>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { state } from '@/store/modules/cohortManager/types';
import OutputVariableChart from '@/components/CohortManager/OutputVariableChart.vue';
import resize from 'vue-resize-directive';
import { getSetValuedVariableGroups } from '@/utils/helpers';

export default {
  directives: {
    resize,
  },
  components: {
    OutputVariableChart,
  },
  data: () => ({
    outputVariableGroups: { groups: [], var2group: {}, var2var: {} },
  }),
  computed: {
    ...mapState('cohortManager', {
      outputVariables: state.OUTPUT_VARIABLES,
    }),
    filteredVars() {
      const v2v = this.outputVariableGroups['var2var'];

      // filter grouped variables except for the first
      return this.outputVariables.filter(v => {
        if (v.label in v2v) {
          return v2v[v.label]['index'] == 1;
        }
        // include all non group variables
        return true;
      });
    },
  },
  watch: {
    outputVariables(nov) {
      this.outputVariableGroups = getSetValuedVariableGroups(nov);
    },
  },
  created() {
    this.outputVariableGroups = getSetValuedVariableGroups(
      this.outputVariables
    );
  },
  methods: {
    userChangedVariable() {
      this.$emit('userChangedOutputVariable', true);
    },
  },
};
</script>

<style scoped>
.horizontal {
  display: flex;
}

.xscrollable {
  overflow-x: auto;
  overflow-y: hidden;
}
</style>
